import React, { Component } from 'react';
import {
    Container,
    Title,
    Item
} from './ProfileChageDialog.style';
import { Dialog } from "@material-ui/core";

import Button from '../../../Common/VMButton';
import TwoBtnDialog from '../../../Common/TwoBtnDialog/TwoBtnDialog'

import i18n from '../../../i18n';

export default class ProfileChangeDialog extends Component {
    state = {
        isOpenDialog: false
    }

    changeProfile = e => this.props.onChangeProfile(e.target.files[0])

    handleOpenDialog = () => this.setState({ isOpenDialog: true })
    handleCloseDialog = () => this.setState({ isOpenDialog: false })
    handleResetProfile = () => {
        this.props.onResetProfile()
        this.setState({ isOpenDialog: false })
    }

    render() {
        const { open, onClose } = this.props
        return (
            <Dialog open={open} onClose={onClose}>
                <Container>
                    <Title>{i18n.t("web.myvideo.change.profile")}</Title>
                    <Item>
                        <label htmlFor='file-upload'>
                            <img src="https://front.videomonster.com/images-7cuytg20/web/profileSelectIcon.svg" alt=''/>
                            <span>{i18n.t("web.myvideo.upload.profile")}</span>
                            <input id="file-upload" type="file" name="reviewImg" accept="image/png, image/jpeg" onChange={this.changeProfile} style={{ display: 'none' }} />
                        </label>
                    </Item>
                    <Item onClick={this.handleOpenDialog}>
                        <img src="https://front.videomonster.com/images-7cuytg20/web/profileResetIcon.svg" alt=''/>
                        <span>{i18n.t("web.myvideo.init.profile")}</span>
                    </Item>
                    <Button style={{margin: "30px auto 0 auto"}} 
                    onClick = {onClose}
                    width = {"100px"}
                    height = {"30px"}>
                    {i18n.t("global.cancel")}
                    </Button>
                </Container>
                <TwoBtnDialog
                    open={this.state.isOpenDialog}
                    onClose={this.handleCloseDialog}
                    onClick={this.handleResetProfile}
                >
                    {i18n.t("web.myvideo.reset.profile.dialog.body")}
                </TwoBtnDialog>
            </Dialog>
        );
    }
}